import React, { FC } from 'react';
import { Box, Button, Text } from '@wix/design-system';
import { useScreenWidth } from '../../../hooks/useScreenWidth';
import { useUouLanguage } from '../../../hooks/useUouLanguage';
import { CalendarProviderData } from '../types';

export interface ConnectCalendarModalSectionProps {
  cardData: CalendarProviderData;
  onChooseProvider(): void;
}

export const ConnectCalendarModalSection: FC<ConnectCalendarModalSectionProps> = ({ cardData, onChooseProvider }) => {
  const { isMobile } = useScreenWidth();
  const language = useUouLanguage();

  return (
    <Box direction="horizontal" verticalAlign="middle" gap={isMobile ? '15px' : '20px'}>
      <Box width="24px">{cardData.logo}</Box>
      <Box direction="horizontal" align="space-between" verticalAlign="middle" gap={isMobile ? '15px' : '20px'} flexGrow="1">
        <Box direction="vertical">
          <Text weight="bold" size={isMobile ? 'small' : 'medium'}>
            {cardData.title}
          </Text>
          <Text size={isMobile ? 'tiny' : 'small'}>{cardData?.subtitle ?? '\n'}</Text>
        </Box>
        <Button size="small" onClick={onChooseProvider}>
          {language.ASA_STANDALONE_CONNECT_CALENDAR_MODAL_CONNECT_CTA()}
        </Button>
      </Box>
    </Box>
  );
};
